export class Setor {}
